import {
  type PostBalltrackerByMachineUuidChallengeData,
  postBalltrackerByMachineUuidChallengeMutation,
} from "@aura-frontend/omnibus-az-client";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { selectRecentEventForReview } from "@/pages/Tagging/store/slices/socket/selectors";
import type { RootState } from "@/pages/Tagging/store/store";

export const useChallengeSubmission = () => {
  const { id: machineUuid } = useParams<{ id: string }>();
  const recentEvent = useSelector((state: RootState) =>
    selectRecentEventForReview(state),
  );

  const challengeMutation = useMutation(
    postBalltrackerByMachineUuidChallengeMutation(),
  );

  const mutate = () => {
    if (!recentEvent.event_uuid || !machineUuid) {
      throw new Error("Missing event UUID or machine UUID");
    }

    const bodyBase = {
      event_uuid: recentEvent.event_uuid,
      machine_uuid: machineUuid,
      event_time: recentEvent.event_time,
    };

    const body = {
      ...bodyBase,
      ...(recentEvent.pitch_data && {
        pitch_data: recentEvent.pitch_data as { [key: string]: unknown },
      }),
      ...(recentEvent.hit_data && {
        hit_data: recentEvent.hit_data as { [key: string]: unknown },
      }),
      ...(recentEvent.tagData && {
        tag_data: recentEvent.tagData as { [key: string]: unknown },
      }),
      ...(recentEvent.aero_data && {
        aero_data: recentEvent.aero_data as { [key: string]: unknown },
      }),
      ...(recentEvent.strike_zone_data && {
        strike_zone_data: recentEvent.strike_zone_data as {
          [key: string]: unknown;
        },
      }),
      ...(recentEvent.ball && { ball: recentEvent.ball }),
      ...(recentEvent.contributing_events?.length && {
        contributing_events: recentEvent.contributing_events,
      }),
      ...(recentEvent.serverTime && {
        server_time_now: recentEvent.serverTime,
      }),
    };

    const options: PostBalltrackerByMachineUuidChallengeData = {
      path: { machine_uuid: machineUuid },
      body,
    };

    challengeMutation.mutate(options);
  };

  return {
    isPending: challengeMutation.isPending,
    mutate,
  };
};
